import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

const ServiceLoggedin = () => {
  const [services, setServices] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
     const token = localStorage.getItem('token');
   
    // if (!token) {
    //   window.location.href = '/signin'; // Redirect to login page
    //   return;
    // }
  fetch(`${process.env.REACT_APP_VENDOR_DOMAIN}/api/services`)
      .then(res => res.json())
      .then(data => {
        const serviceArray = Array.isArray(data)
          ? data
          : Object.values(data);
        // Only display services where is_active is true
        const activeServices = serviceArray.filter(service => service.is_active === true || service.is_active === 1);
        setServices(activeServices);
      })
      .catch(() => setServices([]));
  }, []);

  const handleServiceClick = (id) => {
    navigate(`/service_customer_details/${id}`);
  };

  const handleBookProvider = () => {
    const token = localStorage.getItem('token');
    if (!token) {
      window.location.href = '/signup';
    } else {
      window.location.href = '/signin/';
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.title}>Available Services</h2>
      <div style={styles.cardGrid}>
        {services.map(service => (
          <div
            key={service.id}
            style={{ ...styles.card, cursor: 'pointer' }}
            onClick={() => handleServiceClick(service.id)}
          >
            {service.image_url && (
              <img
                src={service.image_url}
                alt={service.title || service.name}
                style={{ width: '100%', height: '120px', objectFit: 'cover', borderRadius: '6px', marginBottom: '12px' }}
              />
            )}
            <h3 style={styles.cardTitle}>{service.title || service.name}</h3>
            <p style={styles.cardDesc}>{service.description || ''}</p>
          </div>
        ))}
      </div>

    </div>
  );
};

const styles = {
  container: {
    maxWidth: '900px',
    margin: '40px auto',
    padding: '24px',
    background: '#fff',
    borderRadius: '8px',
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
  },
  title: {
    textAlign: 'center',
    marginBottom: '32px',
    color: '#8d6e36', // brown
    fontSize: '2rem',
    fontWeight: 'bold',
    letterSpacing: '1px',
  },
  cardGrid: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '24px',
    justifyContent: 'center',
  },
  card: {
    background: '#f5f6fa',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
    padding: '24px',
    width: '220px',
    textAlign: 'center',
    transition: 'box-shadow 0.2s',
  },
  cardTitle: {
    margin: '0 0 12px 0',
    color: '#8d6e36', // brown
    fontSize: '1.2rem',
    fontWeight: 'bold',
  },
  cardDesc: {
    color: '#555',
    fontSize: '1rem',
    margin: 0,
  },
  bottomText: {
    marginTop: '40px',
    textAlign: 'center',
    color: '#2e7d32',
    fontSize: '1.15rem',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
    background: 'rgba(110,198,241,0.08)',
    padding: '12px 0',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(110,198,241,0.08)',
  },
  infoCardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: '32px',
    marginTop: '32px',
    marginBottom: '16px',
  },
  infoCard: {
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.10)',
    padding: '24px 18px',
    width: '200px',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    transition: 'box-shadow 0.2s, transform 0.2s',
    cursor: 'pointer',
  },
  infoImg: {
    width: '48px',
    height: '48px',
    marginBottom: '12px',
    borderRadius: '8px',
    boxShadow: '0 1px 4px rgba(110,198,241,0.12)',
  },
  infoTitle: {
    fontSize: '1.1rem',
    color: '#8d6e36', // brown
    marginBottom: '8px',
    fontWeight: 'bold',
    letterSpacing: '0.5px',
  },
  infoDesc: {
    fontSize: '0.98rem',
    color: '#555',
    margin: 0,
  },
  peaceContainer: {
    marginTop: '40px',
    background: '#f5f6fa',
    borderRadius: '10px',
    boxShadow: '0 1px 6px rgba(0,0,0,0.08)',
    padding: '28px 24px',
    maxWidth: '700px',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  peaceTitle: {
    color: '#8d6e36', // brown
    fontSize: '1.3rem',
    fontWeight: 'bold',
    marginBottom: '18px',
    textAlign: 'center',
    letterSpacing: '0.5px',
  },
  peaceList: {
    listStyle: 'disc inside',
    color: '#2e7d32',
    fontSize: '1.08rem',
    paddingLeft: '0',
    margin: 0,
    lineHeight: '1.7',
  },
  peaceHighlight: {
    color: '#8d6e36', // brown
    fontWeight: 'bold',
  },
  peaceImg: {
    width: '100%',
    maxWidth: '320px',
    borderRadius: '8px',
    margin: '12px 0',
    display: 'block',
    boxShadow: '0 1px 4px rgba(110,198,241,0.12)',
  },
  peaceMsg: {
    color: '#388e3c',
    fontWeight: 'bold',
    fontSize: '1.05rem',
    marginTop: '8px',
    display: 'flex',
    alignItems: 'center',
  },
  peaceLink: {
    color: '#8d6e36', // brown
    textDecoration: 'underline',
    fontWeight: 'bold',
  },
  bookBtn: {
    background: 'linear-gradient(90deg, #8d6e36 0%, #388e3c 100%)', // brown to green
    color: '#fff',
    fontWeight: 'bold',
    fontSize: '1.1rem',
    border: 'none',
    borderRadius: '8px',
    padding: '14px 32px',
    cursor: 'pointer',
    boxShadow: '0 2px 8px rgba(141,110,54,0.15)',
    transition: 'background 0.2s, transform 0.2s',
    marginTop: '12px',
  },
};

export default ServiceLoggedin;